import Box from "@mui/material/Box/Box";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup, { RadioGroupProps } from "@mui/material/RadioGroup";
import { ForwardRefRenderFunction, forwardRef, memo } from "react";

interface GenRadioChoiceProp {
  name?: string; // Optional name for the radio choice
  label: string;
  value: string;
  content?: React.ReactNode; // Optional content for additional information
}

export interface GenRadioGroupProps extends RadioGroupProps {
  data: GenRadioChoiceProp[];
  label?: string;
}

const GenRadioGroup: ForwardRefRenderFunction<
  RadioGroupProps,
  GenRadioGroupProps
> = (props, ref) => {
  const { data, label, ...otherProps } = props;
  return (
    <FormControl>
      <RadioGroup {...otherProps} aria-labelledby={label}>
        {data.map((choice) => (
          <>
            <FormControlLabel
              data-testid={`gen-radio-choice-${props.name || "default"}-${
                choice.value
              }`}
              key={`${choice.value}-radio-button`}
              value={choice.value}
              control={<Radio />}
              label={choice.label}
            />
            {choice.content && <Box mr={4}>{choice.content}</Box>}
          </>
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default memo(forwardRef(GenRadioGroup));
